

// Function to retrieve the pixel ID from the URL query parameters
const getPixelIdVerifyID = () => {
  return "1a12c085a4794ca2b35a709078e978c6"
};

function removeAllElements(selector) {
  document.querySelectorAll(selector).forEach(el => el.remove());
}

// Define the function to handle DOM mutations
function handleDomChanges_verifyid_dk(mutationsList) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
            // Remove elements whenever there is a DOM change
            removeAllElements('#shopify-accelerated-checkout');  // By ID
            removeAllElements('#more-payment-options-link');      // By ID
            removeAllElements('[data-shopify="payment-button"]'); // By attribute
            removeAllElements('.shopify-paypal-button');
            removeAllElements('.shopify-payment-button__more-options');
            removeAllElements('.more-payment-options-link');
        }
    }
}

// Set up the MutationObserver
const observer_verifyid_dk = new MutationObserver(handleDomChanges_verifyid_dk);

// Define constants and utilities outside DOMContentLoaded
// Alderskrav for svenske kunder. Gaelder hele kurven uanset produkt-tags --
// aendr til 16 hvis I en dag saelger varer med lavere aldersgraense i SE.
const AGE_REQUIREMENT_VERIFYID = 18;

const tokenKey = "x_token_age_verified";
const deviceIdKey = "device_id_verify_id";

function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    }
  );
}

// Should the age gate run on this pageview?
//
// layout/theme.liquid traeffer beslutningen foerst -- sv-locale, SE-marked
// eller en IP-probe -- og markerer script-tagget med data-av-run="1".
// Resten er fallbacks, saa gaten ikke forsvinder hvis scriptet en dag
// bliver indlaest uden flaget (fx direkte fra en app-embed).
function shouldRunAgeVerificationVerifyID() {
  try {
    if (document.querySelector('script[data-av-run="1"]')) return true;
  } catch (e) {}

  // Svensk marked valgt i Shopify Markets
  if (window?.Shopify?.country === "SE") return true;

  // Svensk sprogversion (/sv-se)
  if (String(window?.Shopify?.locale || "").toLowerCase() === "sv") return true;
  if (/^\/sv(-[a-z]{2})?(\/|$)/i.test(window.location.pathname)) return true;

  // Svensk IP fundet af probe'en i layout
  try {
    if (sessionStorage.getItem("_av_geo_country") === "SE") return true;
  } catch (e) {}

  return false;
}

// Scriptet kan blive injiceret af IP-probe'en EFTER at DOMContentLoaded
// allerede er fyret -- saa ville en ren addEventListener aldrig koere.
function onReadyVerifyID(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn);
  } else {
    fn();
  }
}

onReadyVerifyID(function () {
    if (!shouldRunAgeVerificationVerifyID()) {
        console.log("Age verification: Not Sweden, skipping");
        return;
    }

    console.log("Age verification: Sweden detected, initializing");

    // Aldersverificering kraeves ALTID for svenske kunder -- uanset hvad der
    // ligger i kurven. Derfor er produkt-katalog-hentningen fjernet: den
    // hentede hele /products.json (250 ad gangen, alle sider) alene for at
    // kunne slaa 18+/16+-tags op per vare. Ingen tags = intet opslag.

    // Start observing DOM changes after DOM is ready
    if (document.body) {
      observer_verifyid_dk.observe(document.body, {
        childList: true,
        attributes: true,
        subtree: true
      });
    }

    // Kraev altid aldersverificering foer checkout.
    //
    // Tidligere hentede den /cart.json og slog hver vares 18+/16+-tag op for
    // at afgoere om gaten overhovedet skulle vises -- og sendte kunden direkte
    // videre til checkout hvis ingen varer var taggede. Nu gaelder gaten alle
    // svenske kunder, saa baade kurv-opslaget og den gennemgaaende sti er vaek.
function verifyIdCheckCart() {
  // Gemmes saa BankID-knapperne i modalen kan laese alderskravet
  localStorage.setItem("ageToCheckVerifyID", AGE_REQUIREMENT_VERIFYID);

  const token = localStorage.getItem("x_token_age_verified");
  const deviceID = localStorage.getItem("device_id_verify_id");

  if (!token || !deviceID) {
    // Ikke verificeret -> vis BankID-modalen og stop checkout
    document.getElementById("verify-modal-overlay").style.display = "block";
    document.getElementById("verify-modal-overlay-verifying").style.display = "none";
    document.getElementById("verify-modal-overlay-nono").style.display = "none";

    return Promise.reject("Age verification required.");
  }

  // Allerede verificeret -> bekraeft at token stadig er gyldig
  document.getElementById("verify-modal-overlay-verifying").style.display = "block";
  document.getElementById("verify-modal-overlay-nono").style.display = "none";
  document.getElementById("verify-modal-overlay").style.display = "none";

  return Promise.resolve(checkUserAgeToken(token, deviceID, AGE_REQUIREMENT_VERIFYID));
}
window.verifyIdCheckCart=verifyIdCheckCart
    // Helper function to check if an element is a checkout button/link
  function isCheckoutButton(element) {
    // Match specific attributes or href
    if (element.tagName === 'A' && element.getAttribute('href') === '/checkout') return true;
    if (element.tagName === 'BUTTON' && element.getAttribute('name') === 'checkout') {
        element.setAttribute('name', 'checkout_verifyid');
        element.removeAttribute('type');
        element.removeAttribute('id');
        element.removeAttribute('form');
        return true
    } ;
    if (element.tagName === 'BUTTON' && element.getAttribute('name') === 'checkout_verifyid') return true;


    // Match text content
    const text = element.textContent.trim().toLowerCase();
    const keywords = ["checkout", "check out", "gå til betaling", "gå til kasse"];
    return keywords.some(keyword => text.includes(keyword));
  }

  // Add event listener to all current and future buttons/links
  document.body.addEventListener('click', (event) => {

    const target = event.target.closest('a, button'); // Get the nearest <a> or <button>
    if (target && isCheckoutButton(target)) {
      console.log("CheckoutButton: Yes")
      document.getElementById("verify-modal-overlay-verifying").style.display = "block";
      document.getElementById("verify-modal-overlay-nono").style.display = "none";
          document.getElementById("verify-modal-overlay").style.display = "none";


      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        verifyIdCheckCart()
      .then(() => {
        // Additional logic after successful verification
      })
      .catch((error) => {
          console.error('Checkout verification failed:', error);
      });

        // await verifyIdCheckCart();
        // Additional logic after successful checkout
    } catch (error) {
          // Handle errors appropriately
        console.error('Checkout failed:', error);
    }

    }
  });





    // Helper function to remove all elements matching a selector

    // Remove elements by selectors
    removeAllElements('#shopify-accelerated-checkout');  // By ID
    removeAllElements('#more-payment-options-link');      // By ID

    // Remove elements by attribute selector
    removeAllElements('[data-shopify="payment-button"]'); // By attribute

    // Remove elements by class selector
    removeAllElements('.shopify-paypal-button');
    removeAllElements('.shopify-payment-button__more-options');
    removeAllElements('.more-payment-options-link');


  // Create a URL object from the current page's URL
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has("token_age_verified")) {
    const tokenValue = urlParams.get("token_age_verified");
    // Save the token to localStorage
    localStorage.setItem("x_token_age_verified", tokenValue);
    
    // Get or create device ID
    let deviceID = localStorage.getItem(deviceIdKey);
    if (!deviceID) {
      deviceID = generateUUID();
      localStorage.setItem(deviceIdKey, deviceID);
    }
    
    // Validate token and update cart attributes
    fetch(`https://mitid.verifyid.dk/api/auth_check/${tokenValue}`, {
      method: "POST",
    })
      .then(response => response.json())
      .then(response => {
        if (response.age >= 16) {
          // Valid token - update cart with verification data
          handleVerifiedUser(tokenValue, deviceID, response.encrypted_text)
            .then(() => {
              // Clean URL after successful verification
              cleanUrlParams();
            })
            .catch(error => {
              console.error("Error in handleVerifiedUser:", error);
            });
        } else {
          // Invalid age - remove token
          localStorage.removeItem("x_token_age_verified");
          localStorage.removeItem(deviceIdKey);
          console.error("Age verification failed: user too young");
          cleanUrlParams();
        }
      })
      .catch(error => {
        console.error("Error validating token from callback:", error);
        localStorage.removeItem("x_token_age_verified");
        cleanUrlParams();
      });
  }
  const pluginKey = getPixelIdVerifyID();

//   console.log("Plugin Key:", pluginKey);
  if (!pluginKey) {
    return;
  }
  const text_data = {
      verify_popup_title: "Verifiering Krävs",
      verify_popup_description:
        "Enligt svensk lag måste vi verifiera din ålder för att sälja åldersbegränsade produkter.",
      verify_popup_process_1: "Öppna BankID och bekräfta din ålder.",
      verify_popup_process_2: "Tack, du kan nu slutföra din beställning.",
      verify_popup_button: "Bekräfta din ålder med",
      verify_popup_link: "I am a customer from outside of Sweden",
      verifying_popup_title: "Verifierar....",
      verifying_popup_description:
        "Vi följer alla regler för att förhindra försäljning av alkohol och tobak till minderåriga.",
      rejected_popup_title: "Verifiering Nekad",
      rejected_popup_description:
        "Du är under åldersgränsen för vissa varor i din kundvagn. Ta bort dessa varor för att fortsätta med ditt köp.",
      rejected_popup_button_1: "Tillbaka till kundvagnen",
      rejected_popup_button_2: "Bekräfta din ålder med",
      ship_outside_denmark: "yes",
      show_verify_popup_link: true
    };

  if (window.location.host === 'europesnus.se') {
    text_data.ship_outside_denmark = "no"
  };

  const ageVerificationData = { text_data };

  // Insert the "Verify Yourself" button on the page
  const verifyButtonHtml = `
        <button id="verify-yourself" style="display: none;position: fixed; right: 10px; top: 50%; transform: translateY(-50%); background-color: black; color: white; padding: 14px 20px; font-size: 16px; font-weight: 600; border-radius: 6px; border: none; cursor: pointer; z-index: 99999999999999999; writing-mode: vertical-rl; text-orientation: mixed;">
          Verify Yourself
        </button>`;


    const modalHtml = `
    <div id="verify-modal-overlay" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.9); z-index: 99999999999999999;">
    <div id="verify-modal" style="width:370px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:10px;text-align:center;padding: 0 2px !important;">
<div style="border-top-width:4px !important;max-width:370px;background-color:#fff;border-radius:.5rem;padding:0;overflow:hidden;border:1px solid #000;box-shadow:0 0 15px rgba(0,0,0,.1)">
<div style=border-color:#000>
<div style=padding:12px;display:flex;flex-direction:column>
<div style=display:flex;justify-content:center;align-items:center>
<svg width=120 height=26 viewBox="0 0 3274 700" fill=none xmlns=http://www.w3.org/2000/svg data-id=6 bis_size='{"x":136,"y":29,"w":128,"h":26,"abs_x":136,"abs_y":166}'>
<path d="M349.929 699.963C344.216 699.963 338.503 698.249 333.647 694.964C123.262 553.421 1.71561 341.894 0.00167629 114.512C-0.141151 101.229 8.85699 89.5172 21.7115 86.0894L342.502 0.964087C347.359 -0.321362 352.5 -0.321362 357.499 0.964087L678.29 86.0894C691.145 89.5172 700 101.229 700 114.512C698.429 341.751 576.74 553.421 366.355 694.964C361.356 698.249 355.643 699.963 349.929 699.963ZM305.5 372.5C128.251 246.954 297.029 366.5 305.5 372.5C482.749 246.954 348.644 736.389 357.499 543L305.5 372.5Z" fill=#183e4f data-id=7 bis_size='{"x":139,"y":29,"w":26,"h":25,"abs_x":139,"abs_y":166}'></path>
<path d="M341.896 313.104C377.271 313.104 405.948 284.427 405.948 249.052C405.948 213.677 377.271 185 341.896 185C306.521 185 277.844 213.677 277.844 249.052C277.844 284.427 306.521 313.104 341.896 313.104Z" fill=#183e4f stroke=white stroke-width=30 data-id=8 bis_size='{"x":149,"y":35,"w":4,"h":4,"abs_x":149,"abs_y":172}'></path>
<path d="M405.948 441.209H255.625C240.214 441.209 228.29 427.702 230.202 412.41L235.204 372.39C237.608 353.158 253.957 338.726 273.339 338.726H277.843" fill=#183e4f stroke=white stroke-width=30 stroke-linecap=round stroke-linejoin=round data-id=9 bis_size='{"x":147,"y":41,"w":6,"h":3,"abs_x":147,"abs_y":178}'></path>
<path d="M393.137 364.346L421.961 389.967L470 338.726" fill=black stroke=white stroke-width=30 stroke-linecap=round stroke-linejoin=round data-id=10 bis_size='{"x":153,"y":41,"w":2,"h":1,"abs_x":153,"abs_y":178}'></path>
<path d="M1097.6 550H1015.4L854 100H944L1055 420.4H1057.4L1169 100H1257.8L1097.6 550ZM1624.89 376C1624.89 382.8 1624.49 389.4 1623.69 395.8C1622.89 401.8 1621.69 408.2 1620.09 415H1342.29C1349.89 434.2 1362.09 450 1378.89 462.4C1395.69 474.4 1415.09 480.4 1437.09 480.4C1452.69 480.4 1467.09 477.4 1480.29 471.4C1493.49 465 1505.09 456.4 1515.09 445.6H1607.49C1601.49 463.2 1592.69 479.2 1581.10 493.6C1569.89 507.6 1556.89 519.6 1542.09 529.6C1527.29 539.2 1510.89 546.6 1492.89 551.8C1474.89 557.4 1456.29 560.2 1437.09 560.2C1412.69 560.2 1389.09 555.4 1366.29 545.8C1343.49 536.2 1323.29 523.2 1305.69 506.8C1288.49 490 1274.69 470.4 1264.29 448C1253.89 425.6 1248.69 401.6 1248.69 376C1248.69 349.6 1253.69 325.2 1263.69 302.8C1273.69 280.4 1287.29 261 1304.49 244.6C1321.69 228.2 1341.69 215.4 1364.49 206.2C1387.69 197 1412.29 192.4 1438.29 192.4C1463.89 192.4 1487.89 197.2 1510.29 206.8C1533.09 216.4 1552.89 229.4 1569.69 245.8C1586.89 262.2 1600.29 281.6 1609.89 304C1619.89 326.4 1624.89 350.4 1624.89 376ZM1533.69 341.2C1526.49 320 1514.29 303.2 1497.09 290.8C1479.89 278.4 1460.29 272.2 1438.29 272.2C1416.69 272.2 1397.29 278.4 1380.09 290.8C1362.89 303.2 1350.69 320 1343.49 341.2H1533.69ZM1684.91 202.6H1760.51V250.6H1761.71C1766.11 243 1771.31 235.8 1777.31 229C1783.31 221.8 1790.11 215.6 1797.71 210.4C1805.71 204.8 1814.51 200.4 1824.11 197.2C1833.71 194 1844.51 192.4 1856.51 192.4H1863.71V281.8C1860.51 281 1857.31 280.4 1854.11 280C1850.91 279.2 1847.51 278.8 1843.91 278.8C1833.51 278.8 1823.91 280.8 1815.11 284.8C1806.31 288.4 1798.31 293.4 1791.11 299.8C1784.31 306.2 1778.71 313.8 1774.31 322.6C1770.31 331.4 1767.91 340.8 1767.11 350.8V550H1684.91V202.6ZM2002.7 202.6V550H1918.7V202.6H2002.7ZM1913.3 134.8C1913.3 121.6 1917.9 110.4 1927.1 101.2C1936.3 92 1947.5 87.4 1960.7 87.4C1973.9 87.4 1985.1 92 1994.3 101.2C2003.5 110.4 2008.1 121.6 2008.1 134.8C2008.1 148 2003.5 159.2 1994.3 168.4C1985.1 177.6 1973.9 182.2 1960.7 182.2C1947.5 182.2 1936.3 177.6 1927.1 168.4C1917.9 159.2 1913.3 148 1913.3 134.8ZM2220.35 202.6V277H2168.75V550H2087.75V277H2056.55V202.6H2087.75V196.6C2087.75 183.4 2090.35 171 2095.55 159.4C2100.75 147.4 2107.95 137 2117.15 128.2C2126.35 119.4 2137.15 112.6 2149.55 107.8C2161.95 102.6 2175.35 100 2189.75 100H2220.35V175.6H2189.75C2184.15 175.6 2179.15 177.8 2174.75 182.2C2170.75 186.2 2168.75 191 2168.75 196.6V202.6H2220.35ZM2429.05 652.6H2341.45L2384.05 542.2L2252.05 202.6H2340.25L2427.25 428.8H2428.45L2515.45 202.6H2603.05L2429.05 652.6ZM2708.19 100H2793.39V550H2708.19V100ZM3021.82 100C3054.22 100 3084.42 105.6 3112.42 116.8C3140.82 128 3165.42 143.6 3186.22 163.6C3207.02 183.6 3223.22 207.4 3234.82 235C3246.82 262.6 3252.82 292.6 3252.82 325C3252.82 357.4 3246.82 387.4 3234.82 415C3223.22 442.6 3207.02 466.4 3186.22 486.4C3165.42 506.4 3140.82 522 3112.42 533.2C3084.42 544.4 3054.22 550 3021.82 550H2865.22V100H3021.82ZM3164.62 325C3164.62 305.4 3160.82 287 3153.22 269.8C3145.62 252.2 3135.42 237 3122.62 224.2C3109.82 211.4 3094.62 201.2 3077.02 193.6C3059.82 186 3041.42 182.2 3021.82 182.2H2950.42V468.4H3021.82C3041.42 468.4 3059.82 464.6 3077.02 457C3094.62 449.4 3109.82 439.2 3122.62 426.4C3135.42 413.6 3145.62 398.6 3153.22 381.4C3160.82 363.8 3164.62 345 3164.62 325Z" fill=black data-id=11 bis_size='{"x":170,"y":32,"w":89,"h":20,"abs_x":170,"abs_y":169}'></path>
</svg>
</div>
<h2 style='text-transform: none !important;font-size:30px;font-weight:600;text-align:center;color:#1f2937; margin:14px 0 !important;'>
${ageVerificationData?.text_data?.verify_popup_title}
</h2>
<p style='text-transform: none !important;font-size:16px;text-align:center;color:#4b5563;margin-top:0;line-height: 1.4;'>
${ageVerificationData?.text_data?.verify_popup_description}
</p>
<ol style='text-transform: none !important;font-size:16px; margin: 14px 0; list-style-type:decimal;padding-left:16px;background-color:#f9fafb;padding:1rem;border-radius:.375rem;display:flex;flex-direction:column;text-align:left;color:#4b5563;padding-left:25px!important;'>
<li>${ageVerificationData?.text_data?.verify_popup_process_1}</li>
<li>${ageVerificationData?.text_data?.verify_popup_process_2}</li>
</ol>
<button id="verify-mitid" style="width:100%;background-color:#183e4f;color:#fff;padding:.625rem;font-size:16px;font-weight:500;display:flex;justify-content:center;align-items:center;border-radius:.375rem;box-shadow:0 4px 6px rgba(0,0,0,.1);transition:background-color .2s ease,box-shadow .2s ease;border:0;margin:11px 0 22px 0;height: 42px;">
<span style="text-transform: none !important;letter-spacing: normal !important; ">${
        ageVerificationData?.text_data?.verify_popup_button
      }</span>
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="60" viewBox="0 0 290 275" fill="none">
<path d="M91.4993 143.072L103.613 66.7178H90.6733C84.6163 66.7178 76.8157 63.3222 74.5214 57.0816C73.7872 54.9709 72.0435 47.7209 82.0467 40.6544C85.6258 38.1765 87.9202 35.4233 88.379 33.3126C88.8379 31.11 88.2873 29.1828 86.7271 27.7144C84.5246 25.6037 80.2113 24.4106 74.7049 24.4106C65.4359 24.4106 58.9201 29.7334 58.2777 33.5879C57.8188 36.4328 60.0213 38.7271 61.9486 40.1955C67.7302 44.5088 69.1068 50.7493 65.5277 56.6228C61.8568 62.6798 53.8726 66.626 45.3377 66.7178H32.1225C31.0212 74.1513 13.0338 188.133 11.6572 197.126H83.0562C83.6986 193.18 87.0024 171.614 91.4993 143.072Z" fill="white"/>
<path d="M7.80066 223.559H37.0761C49.5571 223.559 52.5856 229.891 51.6679 235.673C50.9337 240.353 47.7217 243.841 42.2153 246.135C49.19 248.797 51.9432 252.926 50.9337 259.442C49.6489 267.61 42.5824 273.667 33.3134 273.667H0L7.80066 223.559ZM27.1646 244.3C32.8545 244.3 35.5159 241.271 36.0666 237.692C36.6172 233.838 34.8735 231.176 29.1836 231.176H24.1362L22.1172 244.3H27.1646ZM24.0444 265.866C29.9178 265.866 33.3134 263.48 34.1394 258.616C34.7818 254.395 32.3957 251.917 26.7058 251.917H21.0159L18.8134 265.958H24.0444V265.866Z" fill="white"/>
<path d="M91.9489 274.031C84.3318 274.582 80.6609 273.756 78.8254 270.452C74.7874 272.93 70.2906 274.215 65.5184 274.215C56.8918 274.215 53.8633 269.718 54.6893 264.762C55.0564 262.376 56.4329 260.082 58.6355 258.155C63.4077 254.025 75.1545 253.474 79.7432 250.354C80.1102 246.867 78.7337 245.582 74.4203 245.582C70.107 245.582 65.1513 247.234 57.9013 252.19L59.645 240.81C65.8855 236.313 71.9425 234.202 78.9172 234.202C85.8919 234.202 95.7116 237.873 94.2432 247.601L92.4995 258.614C91.8571 262.468 92.0407 263.661 96.354 263.753L91.9489 274.031ZM78.7337 256.686C74.6957 259.256 67.1703 258.797 66.3444 264.12C65.9773 266.598 67.5374 268.433 70.0153 268.433C72.4931 268.433 75.3381 267.424 77.7242 265.772C77.5406 264.854 77.6324 263.936 77.9077 262.193L78.7337 256.686Z" fill="white"/>
<path d="M106.174 234.845H121.408L120.582 239.892C125.446 235.762 129.117 234.202 133.889 234.202C142.424 234.202 146.371 239.433 144.994 247.968L141.048 273.573H125.814L129.117 252.373C129.76 248.519 128.567 246.683 125.63 246.683C122.693 246.683 121.041 247.968 118.931 250.813L115.443 273.481H100.209L106.174 234.845Z" fill="white"/>
<path d="M156.932 223.559H172.166L168.311 248.154L182.903 234.847H201.716L182.995 251.366L198.046 273.575H178.865L167.302 255.588H167.118L164.365 273.483H149.131L156.932 223.559Z" fill="white"/>
<path d="M210.804 223.559H228.332L220.623 273.575H203.095L210.804 223.559Z" fill="white"/>
<path d="M236.859 223.559H261.913C281.277 223.559 286.875 237.6 285.04 249.255C283.296 260.635 274.302 273.575 257.325 273.575H229.059L236.859 223.559ZM253.103 261.644C261.638 261.644 266.318 257.423 267.695 248.521C268.704 241.913 266.685 235.397 257.233 235.397H252.552L248.514 261.644H253.103Z" fill="white"/>
<path d="M187.482 0H114.523L104.795 61.7629H117.184C123.975 61.7629 130.399 58.6426 133.153 54.1458C134.07 52.6774 134.437 51.3926 134.437 50.1995C134.437 47.6299 132.694 45.7027 130.95 44.4179C126.178 40.8387 125.168 37.0761 125.168 34.4147C125.168 31.7533 125.168 33.4052 125.26 32.9463C126.27 26.4305 135.08 19.364 146.735 19.364C158.39 19.364 159.032 21.0159 162.244 24.0444C165.089 26.7058 166.191 30.4685 165.365 34.4147C164.355 39.0951 159.675 42.9495 157.013 44.8767C149.947 49.8325 150.865 54.1458 151.324 55.4306C152.792 59.285 158.39 61.7629 162.703 61.7629H181.608C207.305 62.0382 221.071 73.8769 216.757 101.409C212.719 127.013 193.08 138.026 169.678 138.209L160.409 197.311H174.083C231.808 197.311 278.979 160.235 288.248 101.684C299.72 29.0001 253.558 0 187.482 0Z" fill="white"/>
</svg>
</button>
<div style=font-size:16px;text-align:center;color:#6b7280>
<a id="not-from-denmark" href="#" style="text-transform: none !important;color:#4b5563;text-decoration:underline dotted;text-underline-offset:0.125rem;transition:color .2s ease; ${
        ageVerificationData?.text_data?.ship_outside_denmark === "no"
          ? "pointer-events:none;color:grey;display: none;"
          : ""
      }">
${ageVerificationData?.text_data?.verify_popup_link}</a>
</div>
</div>
</div>
</div>
</div></div>`;

const modalHtmlNoNo = `
    <div id="verify-modal-overlay-nono" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.9); z-index: 99999999999999999;">
    <div id="verify-modal-nono" style="width:370px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:10px;text-align:center;padding: 0 2px !important;">
<div style="border-top-width:4px !important;max-width:370px;background-color:#fff;border-radius:.5rem;padding:0;overflow:hidden;border:1px solid #000;box-shadow:0 0 15px rgba(0,0,0,.1)">
<div style=border-color:#000>
<div style=padding:12px;display:flex;flex-direction:column>
<div style=display:flex;justify-content:center;align-items:center>
<svg width=120 height=26 viewBox="0 0 3274 700" fill=none xmlns=http://www.w3.org/2000/svg data-id=6 bis_size='{"x":136,"y":29,"w":128,"h":26,"abs_x":136,"abs_y":166}'>
<path d="M349.929 699.963C344.216 699.963 338.503 698.249 333.647 694.964C123.262 553.421 1.71561 341.894 0.00167629 114.512C-0.141151 101.229 8.85699 89.5172 21.7115 86.0894L342.502 0.964087C347.359 -0.321362 352.5 -0.321362 357.499 0.964087L678.29 86.0894C691.145 89.5172 700 101.229 700 114.512C698.429 341.751 576.74 553.421 366.355 694.964C361.356 698.249 355.643 699.963 349.929 699.963ZM305.5 372.5C128.251 246.954 297.029 366.5 305.5 372.5C482.749 246.954 348.644 736.389 357.499 543L305.5 372.5Z" fill=#183e4f data-id=7 bis_size='{"x":139,"y":29,"w":26,"h":25,"abs_x":139,"abs_y":166}'></path>
<path d="M341.896 313.104C377.271 313.104 405.948 284.427 405.948 249.052C405.948 213.677 377.271 185 341.896 185C306.521 185 277.844 213.677 277.844 249.052C277.844 284.427 306.521 313.104 341.896 313.104Z" fill=#183e4f stroke=white stroke-width=30 data-id=8 bis_size='{"x":149,"y":35,"w":4,"h":4,"abs_x":149,"abs_y":172}'></path>
<path d="M405.948 441.209H255.625C240.214 441.209 228.29 427.702 230.202 412.41L235.204 372.39C237.608 353.158 253.957 338.726 273.339 338.726H277.843" fill=#183e4f stroke=white stroke-width=30 stroke-linecap=round stroke-linejoin=round data-id=9 bis_size='{"x":147,"y":41,"w":6,"h":3,"abs_x":147,"abs_y":178}'></path>
<path d="M393.137 364.346L421.961 389.967L470 338.726" fill=black stroke=white stroke-width=30 stroke-linecap=round stroke-linejoin=round data-id=10 bis_size='{"x":153,"y":41,"w":2,"h":1,"abs_x":153,"abs_y":178}'></path>
<path d="M1097.6 550H1015.4L854 100H944L1055 420.4H1057.4L1169 100H1257.8L1097.6 550ZM1624.89 376C1624.89 382.8 1624.49 389.4 1623.69 395.8C1622.89 401.8 1621.69 408.2 1620.09 415H1342.29C1349.89 434.2 1362.09 450 1378.89 462.4C1395.69 474.4 1415.09 480.4 1437.09 480.4C1452.69 480.4 1467.09 477.4 1480.29 471.4C1493.49 465 1505.09 456.4 1515.09 445.6H1607.49C1601.49 463.2 1592.69 479.2 1581.10 493.6C1569.89 507.6 1556.89 519.6 1542.09 529.6C1527.29 539.2 1510.89 546.6 1492.89 551.8C1474.89 557.4 1456.29 560.2 1437.09 560.2C1412.69 560.2 1389.09 555.4 1366.29 545.8C1343.49 536.2 1323.29 523.2 1305.69 506.8C1288.49 490 1274.69 470.4 1264.29 448C1253.89 425.6 1248.69 401.6 1248.69 376C1248.69 349.6 1253.69 325.2 1263.69 302.8C1273.69 280.4 1287.29 261 1304.49 244.6C1321.69 228.2 1341.69 215.4 1364.49 206.2C1387.69 197 1412.29 192.4 1438.29 192.4C1463.89 192.4 1487.89 197.2 1510.29 206.8C1533.09 216.4 1552.89 229.4 1569.69 245.8C1586.89 262.2 1600.29 281.6 1609.89 304C1619.89 326.4 1624.89 350.4 1624.89 376ZM1533.69 341.2C1526.49 320 1514.29 303.2 1497.09 290.8C1479.89 278.4 1460.29 272.2 1438.29 272.2C1416.69 272.2 1397.29 278.4 1380.09 290.8C1362.89 303.2 1350.69 320 1343.49 341.2H1533.69ZM1684.91 202.6H1760.51V250.6H1761.71C1766.11 243 1771.31 235.8 1777.31 229C1783.31 221.8 1790.11 215.6 1797.71 210.4C1805.71 204.8 1814.51 200.4 1824.11 197.2C1833.71 194 1844.51 192.4 1856.51 192.4H1863.71V281.8C1860.51 281 1857.31 280.4 1854.11 280C1850.91 279.2 1847.51 278.8 1843.91 278.8C1833.51 278.8 1823.91 280.8 1815.11 284.8C1806.31 288.4 1798.31 293.4 1791.11 299.8C1784.31 306.2 1778.71 313.8 1774.31 322.6C1770.31 331.4 1767.91 340.8 1767.11 350.8V550H1684.91V202.6ZM2002.7 202.6V550H1918.7V202.6H2002.7ZM1913.3 134.8C1913.3 121.6 1917.9 110.4 1927.1 101.2C1936.3 92 1947.5 87.4 1960.7 87.4C1973.9 87.4 1985.1 92 1994.3 101.2C2003.5 110.4 2008.1 121.6 2008.1 134.8C2008.1 148 2003.5 159.2 1994.3 168.4C1985.1 177.6 1973.9 182.2 1960.7 182.2C1947.5 182.2 1936.3 177.6 1927.1 168.4C1917.9 159.2 1913.3 148 1913.3 134.8ZM2220.35 202.6V277H2168.75V550H2087.75V277H2056.55V202.6H2087.75V196.6C2087.75 183.4 2090.35 171 2095.55 159.4C2100.75 147.4 2107.95 137 2117.15 128.2C2126.35 119.4 2137.15 112.6 2149.55 107.8C2161.95 102.6 2175.35 100 2189.75 100H2220.35V175.6H2189.75C2184.15 175.6 2179.15 177.8 2174.75 182.2C2170.75 186.2 2168.75 191 2168.75 196.6V202.6H2220.35ZM2429.05 652.6H2341.45L2384.05 542.2L2252.05 202.6H2340.25L2427.25 428.8H2428.45L2515.45 202.6H2603.05L2429.05 652.6ZM2708.19 100H2793.39V550H2708.19V100ZM3021.82 100C3054.22 100 3084.42 105.6 3112.42 116.8C3140.82 128 3165.42 143.6 3186.22 163.6C3207.02 183.6 3223.22 207.4 3234.82 235C3246.82 262.6 3252.82 292.6 3252.82 325C3252.82 357.4 3246.82 387.4 3234.82 415C3223.22 442.6 3207.02 466.4 3186.22 486.4C3165.42 506.4 3140.82 522 3112.42 533.2C3084.42 544.4 3054.22 550 3021.82 550H2865.22V100H3021.82ZM3164.62 325C3164.62 305.4 3160.82 287 3153.22 269.8C3145.62 252.2 3135.42 237 3122.62 224.2C3109.82 211.4 3094.62 201.2 3077.02 193.6C3059.82 186 3041.42 182.2 3021.82 182.2H2950.42V468.4H3021.82C3041.42 468.4 3059.82 464.6 3077.02 457C3094.62 449.4 3109.82 439.2 3122.62 426.4C3135.42 413.6 3145.62 398.6 3153.22 381.4C3160.82 363.8 3164.62 345 3164.62 325Z" fill=black data-id=11 bis_size='{"x":170,"y":32,"w":89,"h":20,"abs_x":170,"abs_y":169}'></path>
</svg>
</div>
<h2 style='text-transform: none !important;font-size:30px;font-weight:600;text-align:center;color:#1f2937; margin:14px 0 !important;'>
Verificering Afvist
</h2>
<p style='text-transform: none !important;font-size:16px;text-align:center;color:#4b5563;margin-top:0;line-height: 1.4;'>
Du er under aldersgrænsen for nogle af varerne i kurven. Fjern venligst disse varer for at fortsætte dit køb
</p>
<button id='back-to-cart' style="width:100%;background-color:#7700ff;color:#fff;padding:.625rem;font-size:16px;font-weight:500;display:flex;justify-content:center;align-items:center;border-radius:.375rem;box-shadow:0 4px 6px rgba(0,0,0,.1);transition:background-color .2s ease,box-shadow .2s ease;border:0;margin:15px 0 0 0;height: 42px;">
        <span style="letter-spacing: normal !important;text-transform: none !important;">Tilbage til kurven</span>
        </button>

<button id="verify-mitid-r" style="width:100%;background-color:#183e4f;color:#fff;padding:.625rem;font-size:16px;font-weight:500;display:flex;justify-content:center;align-items:center;border-radius:.375rem;box-shadow:0 4px 6px rgba(0,0,0,.1);transition:background-color .2s ease,box-shadow .2s ease;border:0;margin:11px 0 22px 0;height: 42px;">
<span style="text-transform: none !important;letter-spacing: normal !important; ">${
        ageVerificationData?.text_data?.verify_popup_button
      }</span>
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="60" viewBox="0 0 290 275" fill="none">
<path d="M91.4993 143.072L103.613 66.7178H90.6733C84.6163 66.7178 76.8157 63.3222 74.5214 57.0816C73.7872 54.9709 72.0435 47.7209 82.0467 40.6544C85.6258 38.1765 87.9202 35.4233 88.379 33.3126C88.8379 31.11 88.2873 29.1828 86.7271 27.7144C84.5246 25.6037 80.2113 24.4106 74.7049 24.4106C65.4359 24.4106 58.9201 29.7334 58.2777 33.5879C57.8188 36.4328 60.0213 38.7271 61.9486 40.1955C67.7302 44.5088 69.1068 50.7493 65.5277 56.6228C61.8568 62.6798 53.8726 66.626 45.3377 66.7178H32.1225C31.0212 74.1513 13.0338 188.133 11.6572 197.126H83.0562C83.6986 193.18 87.0024 171.614 91.4993 143.072Z" fill="white"/>
<path d="M7.80066 223.559H37.0761C49.5571 223.559 52.5856 229.891 51.6679 235.673C50.9337 240.353 47.7217 243.841 42.2153 246.135C49.19 248.797 51.9432 252.926 50.9337 259.442C49.6489 267.61 42.5824 273.667 33.3134 273.667H0L7.80066 223.559ZM27.1646 244.3C32.8545 244.3 35.5159 241.271 36.0666 237.692C36.6172 233.838 34.8735 231.176 29.1836 231.176H24.1362L22.1172 244.3H27.1646ZM24.0444 265.866C29.9178 265.866 33.3134 263.48 34.1394 258.616C34.7818 254.395 32.3957 251.917 26.7058 251.917H21.0159L18.8134 265.958H24.0444V265.866Z" fill="white"/>
<path d="M91.9489 274.031C84.3318 274.582 80.6609 273.756 78.8254 270.452C74.7874 272.93 70.2906 274.215 65.5184 274.215C56.8918 274.215 53.8633 269.718 54.6893 264.762C55.0564 262.376 56.4329 260.082 58.6355 258.155C63.4077 254.025 75.1545 253.474 79.7432 250.354C80.1102 246.867 78.7337 245.582 74.4203 245.582C70.107 245.582 65.1513 247.234 57.9013 252.19L59.645 240.81C65.8855 236.313 71.9425 234.202 78.9172 234.202C85.8919 234.202 95.7116 237.873 94.2432 247.601L92.4995 258.614C91.8571 262.468 92.0407 263.661 96.354 263.753L91.9489 274.031ZM78.7337 256.686C74.6957 259.256 67.1703 258.797 66.3444 264.12C65.9773 266.598 67.5374 268.433 70.0153 268.433C72.4931 268.433 75.3381 267.424 77.7242 265.772C77.5406 264.854 77.6324 263.936 77.9077 262.193L78.7337 256.686Z" fill="white"/>
<path d="M106.174 234.845H121.408L120.582 239.892C125.446 235.762 129.117 234.202 133.889 234.202C142.424 234.202 146.371 239.433 144.994 247.968L141.048 273.573H125.814L129.117 252.373C129.76 248.519 128.567 246.683 125.63 246.683C122.693 246.683 121.041 247.968 118.931 250.813L115.443 273.481H100.209L106.174 234.845Z" fill="white"/>
<path d="M156.932 223.559H172.166L168.311 248.154L182.903 234.847H201.716L182.995 251.366L198.046 273.575H178.865L167.302 255.588H167.118L164.365 273.483H149.131L156.932 223.559Z" fill="white"/>
<path d="M210.804 223.559H228.332L220.623 273.575H203.095L210.804 223.559Z" fill="white"/>
<path d="M236.859 223.559H261.913C281.277 223.559 286.875 237.6 285.04 249.255C283.296 260.635 274.302 273.575 257.325 273.575H229.059L236.859 223.559ZM253.103 261.644C261.638 261.644 266.318 257.423 267.695 248.521C268.704 241.913 266.685 235.397 257.233 235.397H252.552L248.514 261.644H253.103Z" fill="white"/>
<path d="M187.482 0H114.523L104.795 61.7629H117.184C123.975 61.7629 130.399 58.6426 133.153 54.1458C134.07 52.6774 134.437 51.3926 134.437 50.1995C134.437 47.6299 132.694 45.7027 130.95 44.4179C126.178 40.8387 125.168 37.0761 125.168 34.4147C125.168 31.7533 125.168 33.4052 125.26 32.9463C126.27 26.4305 135.08 19.364 146.735 19.364C158.39 19.364 159.032 21.0159 162.244 24.0444C165.089 26.7058 166.191 30.4685 165.365 34.4147C164.355 39.0951 159.675 42.9495 157.013 44.8767C149.947 49.8325 150.865 54.1458 151.324 55.4306C152.792 59.285 158.39 61.7629 162.703 61.7629H181.608C207.305 62.0382 221.071 73.8769 216.757 101.409C212.719 127.013 193.08 138.026 169.678 138.209L160.409 197.311H174.083C231.808 197.311 278.979 160.235 288.248 101.684C299.72 29.0001 253.558 0 187.482 0Z" fill="white"/>
</svg>
</button>

</div>
</div>
</div>
</div></div>`;

const modalHtmlVerifying = `
    <div id="verify-modal-overlay-verifying" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(255, 255, 255, 0.9); z-index: 99999999999999999;">
    <div id="verify-modal-verifying" style="width:370px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:10px;text-align:center;padding: 0 2px !important;">
<div style="border-top-width:4px !important;max-width:370px;background-color:#fff;border-radius:.5rem;padding:0;overflow:hidden;border:1px solid #000;box-shadow:0 0 15px rgba(0,0,0,.1)">
<div style=border-color:#000>
<div style=padding:12px;display:flex;flex-direction:column>
<div style=display:flex;justify-content:center;align-items:center>
<svg width=120 height=26 viewBox="0 0 3274 700" fill=none xmlns=http://www.w3.org/2000/svg data-id=6 bis_size='{"x":136,"y":29,"w":128,"h":26,"abs_x":136,"abs_y":166}'>
<path d="M349.929 699.963C344.216 699.963 338.503 698.249 333.647 694.964C123.262 553.421 1.71561 341.894 0.00167629 114.512C-0.141151 101.229 8.85699 89.5172 21.7115 86.0894L342.502 0.964087C347.359 -0.321362 352.5 -0.321362 357.499 0.964087L678.29 86.0894C691.145 89.5172 700 101.229 700 114.512C698.429 341.751 576.74 553.421 366.355 694.964C361.356 698.249 355.643 699.963 349.929 699.963ZM305.5 372.5C128.251 246.954 297.029 366.5 305.5 372.5C482.749 246.954 348.644 736.389 357.499 543L305.5 372.5Z" fill=#183e4f data-id=7 bis_size='{"x":139,"y":29,"w":26,"h":25,"abs_x":139,"abs_y":166}'></path>
<path d="M341.896 313.104C377.271 313.104 405.948 284.427 405.948 249.052C405.948 213.677 377.271 185 341.896 185C306.521 185 277.844 213.677 277.844 249.052C277.844 284.427 306.521 313.104 341.896 313.104Z" fill=#183e4f stroke=white stroke-width=30 data-id=8 bis_size='{"x":149,"y":35,"w":4,"h":4,"abs_x":149,"abs_y":172}'></path>
<path d="M405.948 441.209H255.625C240.214 441.209 228.29 427.702 230.202 412.41L235.204 372.39C237.608 353.158 253.957 338.726 273.339 338.726H277.843" fill=#183e4f stroke=white stroke-width=30 stroke-linecap=round stroke-linejoin=round data-id=9 bis_size='{"x":147,"y":41,"w":6,"h":3,"abs_x":147,"abs_y":178}'></path>
<path d="M393.137 364.346L421.961 389.967L470 338.726" fill=black stroke=white stroke-width=30 stroke-linecap=round stroke-linejoin=round data-id=10 bis_size='{"x":153,"y":41,"w":2,"h":1,"abs_x":153,"abs_y":178}'></path>
<path d="M1097.6 550H1015.4L854 100H944L1055 420.4H1057.4L1169 100H1257.8L1097.6 550ZM1624.89 376C1624.89 382.8 1624.49 389.4 1623.69 395.8C1622.89 401.8 1621.69 408.2 1620.09 415H1342.29C1349.89 434.2 1362.09 450 1378.89 462.4C1395.69 474.4 1415.09 480.4 1437.09 480.4C1452.69 480.4 1467.09 477.4 1480.29 471.4C1493.49 465 1505.09 456.4 1515.09 445.6H1607.49C1601.49 463.2 1592.69 479.2 1581.10 493.6C1569.89 507.6 1556.89 519.6 1542.09 529.6C1527.29 539.2 1510.89 546.6 1492.89 551.8C1474.89 557.4 1456.29 560.2 1437.09 560.2C1412.69 560.2 1389.09 555.4 1366.29 545.8C1343.49 536.2 1323.29 523.2 1305.69 506.8C1288.49 490 1274.69 470.4 1264.29 448C1253.89 425.6 1248.69 401.6 1248.69 376C1248.69 349.6 1253.69 325.2 1263.69 302.8C1273.69 280.4 1287.29 261 1304.49 244.6C1321.69 228.2 1341.69 215.4 1364.49 206.2C1387.69 197 1412.29 192.4 1438.29 192.4C1463.89 192.4 1487.89 197.2 1510.29 206.8C1533.09 216.4 1552.89 229.4 1569.69 245.8C1586.89 262.2 1600.29 281.6 1609.89 304C1619.89 326.4 1624.89 350.4 1624.89 376ZM1533.69 341.2C1526.49 320 1514.29 303.2 1497.09 290.8C1479.89 278.4 1460.29 272.2 1438.29 272.2C1416.69 272.2 1397.29 278.4 1380.09 290.8C1362.89 303.2 1350.69 320 1343.49 341.2H1533.69ZM1684.91 202.6H1760.51V250.6H1761.71C1766.11 243 1771.31 235.8 1777.31 229C1783.31 221.8 1790.11 215.6 1797.71 210.4C1805.71 204.8 1814.51 200.4 1824.11 197.2C1833.71 194 1844.51 192.4 1856.51 192.4H1863.71V281.8C1860.51 281 1857.31 280.4 1854.11 280C1850.91 279.2 1847.51 278.8 1843.91 278.8C1833.51 278.8 1823.91 280.8 1815.11 284.8C1806.31 288.4 1798.31 293.4 1791.11 299.8C1784.31 306.2 1778.71 313.8 1774.31 322.6C1770.31 331.4 1767.91 340.8 1767.11 350.8V550H1684.91V202.6ZM2002.7 202.6V550H1918.7V202.6H2002.7ZM1913.3 134.8C1913.3 121.6 1917.9 110.4 1927.1 101.2C1936.3 92 1947.5 87.4 1960.7 87.4C1973.9 87.4 1985.1 92 1994.3 101.2C2003.5 110.4 2008.1 121.6 2008.1 134.8C2008.1 148 2003.5 159.2 1994.3 168.4C1985.1 177.6 1973.9 182.2 1960.7 182.2C1947.5 182.2 1936.3 177.6 1927.1 168.4C1917.9 159.2 1913.3 148 1913.3 134.8ZM2220.35 202.6V277H2168.75V550H2087.75V277H2056.55V202.6H2087.75V196.6C2087.75 183.4 2090.35 171 2095.55 159.4C2100.75 147.4 2107.95 137 2117.15 128.2C2126.35 119.4 2137.15 112.6 2149.55 107.8C2161.95 102.6 2175.35 100 2189.75 100H2220.35V175.6H2189.75C2184.15 175.6 2179.15 177.8 2174.75 182.2C2170.75 186.2 2168.75 191 2168.75 196.6V202.6H2220.35ZM2429.05 652.6H2341.45L2384.05 542.2L2252.05 202.6H2340.25L2427.25 428.8H2428.45L2515.45 202.6H2603.05L2429.05 652.6ZM2708.19 100H2793.39V550H2708.19V100ZM3021.82 100C3054.22 100 3084.42 105.6 3112.42 116.8C3140.82 128 3165.42 143.6 3186.22 163.6C3207.02 183.6 3223.22 207.4 3234.82 235C3246.82 262.6 3252.82 292.6 3252.82 325C3252.82 357.4 3246.82 387.4 3234.82 415C3223.22 442.6 3207.02 466.4 3186.22 486.4C3165.42 506.4 3140.82 522 3112.42 533.2C3084.42 544.4 3054.22 550 3021.82 550H2865.22V100H3021.82ZM3164.62 325C3164.62 305.4 3160.82 287 3153.22 269.8C3145.62 252.2 3135.42 237 3122.62 224.2C3109.82 211.4 3094.62 201.2 3077.02 193.6C3059.82 186 3041.42 182.2 3021.82 182.2H2950.42V468.4H3021.82C3041.42 468.4 3059.82 464.6 3077.02 457C3094.62 449.4 3109.82 439.2 3122.62 426.4C3135.42 413.6 3145.62 398.6 3153.22 381.4C3160.82 363.8 3164.62 345 3164.62 325Z" fill=black data-id=11 bis_size='{"x":170,"y":32,"w":89,"h":20,"abs_x":170,"abs_y":169}'></path>
</svg>
</div>
<h2 style='text-transform: none !important;font-size:30px;font-weight:900;text-align:center;color:#1f2937; margin:20px 0 !important;'>
Verificering....
</h2>
</div>
</div>
</div>
</div></div>`;


  document.body.insertAdjacentHTML("beforeend", modalHtml);
  document.body.insertAdjacentHTML("beforeend", modalHtmlVerifying);
  document.body.insertAdjacentHTML("beforeend", modalHtmlNoNo);


  document.body.insertAdjacentHTML("beforeend", verifyButtonHtml);

  // Initialize device ID if needed
  let deviceID = localStorage.getItem(deviceIdKey);
  if (!deviceID) {
    deviceID = generateUUID();
    localStorage.setItem(deviceIdKey, deviceID);
  }

  // Check if token exists and validate age on page load
  let token = localStorage.getItem(tokenKey);
  if (token && deviceID) {
    checkUserAge(token, deviceID);
  } else {
    document.getElementById("verify-yourself").style.display = "none";
  }

  // Show the modal on "Verify Yourself" button click
  document
    .getElementById("verify-yourself")
    .addEventListener("click", function () {
      document.getElementById("verify-modal-overlay").style.display = "block";
    });

    document
        .getElementById("not-from-denmark")
        .addEventListener("click", function (e) {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "checkout";
          e.preventDefault();
          closeModal();
        });

  document
    .getElementById("back-to-cart")
    .addEventListener("click", function (e) {
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "cart";
      e.preventDefault();
      closeModal();
    });

  // 16+ Verification Click
  document.getElementById("verify-mitid").addEventListener("click", function () {

    verifyAge(localStorage.getItem("ageToCheckVerifyID") || 18);
    this.innerHTML = "<span>Verificering....</span>";
    this.disabled = true;
    document.getElementById("verify-mitid").disabled = true;
  });

  document.getElementById("verify-mitid-r").addEventListener("click", function () {
    verifyAge(localStorage.getItem("ageToCheckVerifyID") || 18);
    this.innerHTML = "<span>Verificering....</span>";
    this.disabled = true;
    document.getElementById("verify-mitid-r").disabled = true;
  });


  function closeModal() {
      document.getElementById("verify-modal-overlay-nono").style.display = "none";
          document.getElementById("verify-modal-overlay").style.display = "none";
          document.getElementById("verify-modal-overlay-verifying").style.display = "none";
  }

  function checkUserAge(token, deviceID) {
  // This function only validates the token - does NOT redirect to checkout
  fetch(`https://mitid.verifyid.dk/api/auth_check/${token}`, {
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.age >= 16) {
          // Token is valid - just hide the verify button, don't redirect
          document.getElementById("verify-yourself").style.display = "none";
          console.log("Age verified:", response.age);
        } else {
          // Token invalid or age too low - clear it
          localStorage.removeItem("x_token_age_verified");
          localStorage.removeItem("device_id_verify_id");
          console.log("Token invalid or age insufficient");
        }
      })
      .catch((error) => {
        console.error("Error checking age:", error);
        // Clear invalid token
        localStorage.removeItem("x_token_age_verified");
        localStorage.removeItem("device_id_verify_id");
      });
  }

  function cleanUrlParams() {
    if (window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.delete('token_age_verified');
      window.history.replaceState({}, document.title, url.toString());
    }
  }

  function checkUserAgeToken(token, deviceID, minAge) {
      document.getElementById("verify-modal-overlay-verifying").style.display = "block";
    return fetch(`https://mitid.verifyid.dk/api/auth_check/${token}`, {
      method: "POST",
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.age >= minAge) {
          // Age verified - update cart attributes then redirect
          return handleVerifiedUser(token, deviceID, response.encrypted_text);
        } else {
          // Age too low - show rejection modal
          document.getElementById("verify-modal-overlay-verifying").style.display = "none";
          document.getElementById("verify-modal-overlay").style.display = "none";
          document.getElementById("verify-modal-overlay-nono").style.display = "block";
          console.log("User does not meet minimum age requirements.");
          return false;
        }
      })
      .catch((error) => {
        console.error("Error checking age:", error);
        // Show error - return to verification modal
        document.getElementById("verify-modal-overlay-verifying").style.display = "none";
        document.getElementById("verify-modal-overlay-nono").style.display = "none";
        document.getElementById("verify-modal-overlay").style.display = "block";
        return Promise.reject(error);
      });
  }

  function verifyAge(ageLevel) {
    const currentDomain = encodeURIComponent(window.location.href);
    window.location.href = `https://mitid.verifyid.dk/api/connect-bankid/${pluginKey}/${ageLevel}?domain=${currentDomain}`;
  }

  function handleVerifiedUser(token, deviceID, encrypted_text) {

      document.getElementById("verify-modal-overlay-nono").style.display = "none";
  document.getElementById("verify-modal-overlay").style.display = "none";
  document.getElementById("verify-modal-overlay-verifying").style.display = "block";

    // Save token in localStorage
    localStorage.setItem(tokenKey, token);

    const attributes = {
      x_token_age_verified: token,
      age_verified_token: encrypted_text,
      device_id_verify_id: deviceID,
    };

    // Update Shopify cart and return the promise
    return fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ attributes }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Cart updated:", data);
        // Keep tokens in localStorage for future verification checks
        // localStorage.removeItem("x_token_age_verified");
        // localStorage.removeItem("device_id_verify_id");

        // Redirect to checkout - modal will disappear automatically
        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/") + "checkout";
        return true;
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
        // Show error - return to verification modal
        document.getElementById("verify-modal-overlay-verifying").style.display = "none";
        document.getElementById("verify-modal-overlay-nono").style.display = "none";
        document.getElementById("verify-modal-overlay").style.display = "block";
        return Promise.reject(error);
      });
  }
});